import React, { Component, Fragment } from 'react';
import AdSense from 'react-adsense';

export default class GoogleAdd extends Component {
  render() {
    return (
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <AdSense.Google
              client="ca-pub-2465816711293362"
              slot="3318147937"
              style={{ display: 'block' }}
              format="auto"
              responsive="true"
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GoogleAdd.jsx